:host{color:#232426de}:host div{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
/*# sourceMappingURL=focused-annotation-label.component.css.map */
